<template>
  <div>
    <select class="form-control" @change="onChanged($event)">
      <option :selected="selectedVal == 0" value="0"
        >---{{ $t("messages.general.notSpecified") }}---</option
      >
      <option
        v-for="(item, index) in items"
        :key="index"
        :value="item.DEPARTMENTID"
        :selected="selectedVal == item.DEPARTMENTID"
      >
        {{ item.DEPARTMENTID }}:{{ item.DEPARTMENTNAME }}
      </option>
    </select>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import MasterDataProvider from "@/services/masterData_provider";

const masterDataProvider = new MasterDataProvider();

export default {
  name: "Department",
  props: {
    onChanged: Function,
    facultyid: Number,
    selectedVal: Number
  },
  data: () => {
    return {
      items: []
    };
  },
  computed: {
    ...mapGetters("application", {
      appInfo: "getUserInfo",
      token: "getToken"
    }),
    currentLang: function() {
      return this.appInfo.currentLocale;
    }
  },
  async mounted() {
    this.loadData();
  },
  methods: {
    ...mapActions("application", ["togglePreLoader"]),
    async loadData() {
      this.togglePreLoader(true);
      this.items = await masterDataProvider.getDepartment({
        facultyid: this.facultyid,
        token: this.token,
        lang: this.currentLang
      });
      this.togglePreLoader(false);
    }
  },
  watch: {
    facultyid: async function() {
      this.items = await masterDataProvider.getDepartment({
        facultyid: this.facultyid,
        token: this.token,
        lang: this.currentLang
      });
    },
    currentLang() {
      this.loadData();
    }
  }
};
</script>
